import type { DeepRequired } from '../fixtures.types'

const awaitedPayment: DeepRequired<AwaitedPayment> = {
  __typename: 'AwaitedPayment',
  id: 'TEST_ID',
  url: null,
  amount: null,
  case_id: null,
  org_id: null,
  organisation: null,
}

export default awaitedPayment
